<template>
    <div class="layout__footer">
        <footer class="footer">
            <div class="container container_wide">
                <div class="footer__top">
                    <div class="footer__left">
                        <a class="footer-logo" href="#">
                            <img class="logo" :src="logoSrc" :alt="`${brandLabel} logo`" />
                        </a>
                    </div>
                    <div class="footer__right">
                        <div class="footer__link" v-if="!shouldHideEaivtLink">
                            <a href="https://www.eaivt.org/" target="_blank">
                                <img src="/img/logos/eaivt.png" alt="E.A.I.V.T. logo" />
                            </a>
                        </div>
                        <div class="footer__socials">
                            <a :href="footerData?.facebook_link" target="_blank" rel="nofollow">
                                <svg class="sprite-icon">
                                    <use xlink:href="/img/sprite.svg#facebook"></use>
                                </svg>
                            </a>
                            <a :href="footerData?.instagram_link" target="_blank" rel="nofollow">
                                <svg class="sprite-icon">
                                    <use xlink:href="/img/sprite.svg#instagram"></use>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
                <!-- old version  -->
                <!-- <div class="footer__top">
                    <div class="footer__left">
                        <a class="footer-logo" href="#">
                            <svg class="sprite-icon">
                                <use xlink:href="/img/sprite.svg#logo"></use>
                            </svg>
                        </a>
                        <div class="footer__address">
                            <div v-html="footerData?.address"></div>
                        </div>
                        <div class="footer__socials">
                            <a
                                :href="footerData?.facebook_link"
                                target="_blank"
                                rel="nofollow"
                            >
                                <svg class="sprite-icon">
                                    <use xlink:href="/img/sprite.svg#facebook"></use>
                                </svg>
                            </a>
                            <a
                                :href="footerData?.instagram_link"
                                target="_blank"
                                rel="nofollow"
                            >
                                <svg class="sprite-icon">
                                    <use xlink:href="/img/sprite.svg#instagram"></use>
                                </svg>
                            </a>
                        </div>
                        <div class="footer__link">
                            <a href="https://www.eaivt.org/" target="_blank">
                                <img src="/img/logos/eaivt.png" alt="E.A.I.V.T. logo" />
                            </a>
                        </div>
                    </div>
                    <div class="footer__right">
                        <div class="h4 footer__title">{{ footerData?.title }}</div>
                        <div class="footer__contact">
                            <div v-html="footerData?.working_hours"></div>
                            <a :href="'tel:' + footerData?.phone" target="_blank">
                                {{ footerData?.phone }}
                            </a>
                            <br />
                            <a :href="'mailto:' + footerData?.email" target="_blank">
                                {{ footerData?.email }}
                            </a>
                        </div>
                    </div>
                </div> -->
                <div class="footer__bottom" :class="{ 'is-work-in-progress-page': isWorkInProgressPage }">
                    <div class="footer__left">
                        <div class="footer__copy">
                            {{ footerData?.copyright }}
                        </div>
                        <nav class="footer__nav">
                            <ul>
                                <li>
                                    <a @click="redirectToTermsAndConditions">
                                        <i18n-t keypath="footer.nav.terms" />
                                    </a>
                                </li>
                                <li>
                                    <a @click="redirectToPrivacy">
                                        <i18n-t keypath="footer.nav.privacy" />
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script lang="ts">
import { setup, Vue } from "vue-class-component";
import { GlobalResponseType } from "@/shared/models/response";
import { watchEffect, shallowRef } from "vue";
import axios from "axios";
import { appLanguageSwitcherModel } from "@/shared/components/app-language-switcher/app-language-switcher.model";
import { Prop } from "vue-property-decorator";
import { routerModel } from "@/router/router.model";
import { getEnvValue } from "@/shared/models/environment";

const HIDE_EAIVT_LINK_BRANDS = ["astara"];

export interface FooterResponse {
    title: string;
    address: string;
    working_hours: string;
    facebook_link: string;
    instagram_link: string;
    phone: string;
    email: string;
    copyright: string;
}

export default class VehiclesFooter extends Vue {
    footerResponse?: GlobalResponseType<FooterResponse> = setup(() => shallowRef());
    @Prop()
    isWorkInProgressPage;
    lang = appLanguageSwitcherModel.lang.value;
    async mounted() {
        watchEffect(async () => {
            await axios
                .get("/api/pages/regions")
                .then((res) => {
                    res.data.data.forEach((d) => {
                        if (d.template === "footer") {
                            this.footerResponse = d;
                        }
                    });
                })
                .catch((err) => console.log(err));
        });
    }

    get footerData() {
        return this.footerResponse?.data[appLanguageSwitcherModel.lang.value];
    }

    redirectToPrivacy() {
        routerModel.router.push("/" + this.lang + "/privacy");
    }

    redirectToTermsAndConditions() {
        routerModel.router.push("/terms-and-conditions");
    }

    get brandLabel() {
        return getEnvValue("BRAND_LABEL");
    }

    get shouldHideEaivtLink() {
        return HIDE_EAIVT_LINK_BRANDS.includes(this.brandLabel);
    }

    get logoSrc() {
        if (this.brandLabel === "astara") {
            return `/img/${this.brandLabel}/logos/logo-color.svg`;
        }
        return `/img/${this.brandLabel}/logos/logo.svg`;
    }
}
</script>

<style scoped>
.footer__top {
    justify-content: space-around;
    padding-bottom: 25px;
}

.footer__left {
    flex: unset;
}

.footer__right {
    flex-direction: row;
    gap: 1em;
}

.footer__link {
    margin-top: 0;
}

.footer__socials {
    display: flex;
    gap: 1em;
}

.footer__socials a:not(:last-child) {
    margin-right: 0;
}

@media (min-width: 768px) {
    .footer-logo {
        margin: 0 auto 1em;
        margin-bottom: 0;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        max-width: 10em;
        height: 1.33em;
        color: #283747;
    }
}

@media (max-width: 768px) {

    .footer__left,
    .footer__right {
        flex: unset;
    }

    .footer__top {
        justify-content: space-around;
        padding-bottom: 0;
    }

    .footer__left {
        flex: unset;
    }

    .footer__right {
        display: flex;
        flex-direction: row;
        gap: 1em;
        margin-top: 0;
    }

    .footer__link {
        margin-top: 0;
    }

    .footer__socials {
        display: flex;
        gap: 1em;
    }

    .footer__socials a:not(:last-child) {
        margin-right: 0;
    }

    .footer-logo {
        margin: 0;
        color: #283747;
    }

    .footer-logo>svg {
        width: 10em;
        height: 2em;
        color: #283747;
    }
}
</style>
